<template>
    <ClassroomLayout>
        <div class="classroom-early">
            <h3>Your next class starts in</h3>
        </div>
        <CountdownTimer v-if="countingDown" :start-time-utc="startTimeUtc" :notify-at-minutes-left="maxEarlyMins"
            @targetTimeReached="onMaxEarlyMinsReached" @ended="onCountdownEnded" />
        <div :class="['classroom-early-button', canJoin ? 'on' : '']">
            <div class="button button-big" @click="joinClick">Join</div>
        </div>
    </ClassroomLayout>
</template>

<script setup>

import ClassroomLayout from "@/components/classroom/ClassroomLayout.vue";
import CountdownTimer from "@/components/CountdownTimer.vue";
import { onMounted, ref } from "vue";

const props = defineProps({
    startTimeUtc: Number,
    maxEarlyMins: Number
});
const emit = defineEmits(['joinCall']);

const countingDown = ref(true),
    canJoin = ref(false);

// Helper to check if we are currently within the "Join" window
function checkInitialState() {
    const now = Date.now();
    const msUntilStart = props.startTimeUtc - now;
    const minutesUntilStart = msUntilStart / (1000 * 60);

    // 1. Should we show the countdown? (Only if the lesson hasn't started yet)
    countingDown.value = msUntilStart > 0;

    // 2. Should the Join button be visible? 
    // Yes, if we are less than 'maxEarlyMins' minutes away from start
    if (minutesUntilStart <= props.maxEarlyMins) {
        canJoin.value = true;
    }
}

onMounted(() => {
    checkInitialState();
})

function joinClick() {
    emit('joinCall');
}

function onMaxEarlyMinsReached() {
    canJoin.value = true;
}

function onCountdownEnded() {
    countingDown.value = false;
    emit('joinCall');
}
</script>

<style lang="scss" scoped>
.classroom-early {
    text-align: center;
    max-width: 600px;
    padding: 0 20px;
    margin: 0 auto;

    &-button {
        visibility: hidden;
        display: flex;
        justify-content: center;
        margin-top: 2rem;

        &.on {
            visibility: visible;
        }
    }

    h3 {
        margin-bottom: 50px
    }
}
</style>
